export interface MockDemo {
  a: Function;
}

/**
 * 表单默认参数
 */
export const editDefaultValue = {
  number: { // 门店编号
    maxLength: '20'
  },
  name: { // 门店名称
    maxLength: '30'
  },
  address: { // 门店地址
    maxLength: '50'
  },
  position: { // 经纬度
    maxLength: '30'
  },
  freeRentPeriod: { // 免租期（天）
    maxLength: '50'
  },
  firstYearMonthRent: { // 首年月租金
    unit: '元'
  },
  secondYearMonthRent: { // 次年月租金
    unit: '元'
  },
  thirdYearMonthRent: { // 第三年月租金
    unit: '元'
  },
  brokerage: { // 扣点值
    unit: '%',
    max: 100,
  },
  desc: { // 递增描述
    maxLength: '300'
  },
  engineeringInfo: {
    maxLength: '300'
  },
  operationInfo: {
    maxLength: '300'
  },
  picUrls: { // 门店照片
    maxCount: 5,
    size: 20,
    fileType: ['png', 'jpg', 'jpeg', 'gif', 'bmp']
  },
  attachment: { // 合同附件
    maxCount: 1,
    fileType: ['doc', 'docx', 'pdf', 'xls', 'xlsx']
  }
};

// 图片字段
export const imagePropertyNames = [
  'picUrls',
];
